import React, { useEffect, useState } from "react";
import Table from "../../../shared/components/pagination/Datatable";
import api from "../../../core/api/config";

const UsuarioAcessoRelatorioPage = () => {
  const [relatorios, setRelatorios] = useState([]);
  const [totalAcesso, setTotalAcesso] = useState(0);
  const [codigoMunicipioUsuario, setCodigoMunicipioUsuario] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [, setTotalPages] = useState(1);

  const [estabelecimentos, setEstabelecimentos] = useState([]);
  const [selectedCnes, setSelectedCnes] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");

  const [tipoAcesso, setTipoAcesso] = useState(null);
  const [userIdLogado, setUserIdLogado] = useState(null);
  const [estabelecimentoId, setEstabelecimentoId] = useState(null);
  const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState("");
  const [nomeEstabelecimento, setNomeEstabelecimento] = useState("");

  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");

  const [imprimindo, setImprimindo] = useState(false);
  const [erro, setErro] = useState("");

  // ⬇ CORREÇÃO — formatar datas sem usar new Date()
  const formatarDataParaAPI = (dataString, isFim = false) => {
    if (!dataString) return "";
    const [ano, mes, dia] = dataString.split("-");
    return isFim
      ? `${ano}-${mes}-${dia}T23:59:59-03:00`
      : `${ano}-${mes}-${dia}T00:00:00-03:00`;
  };

  // carregar dados do usuário logado
  useEffect(() => {
    async function loadUsuario() {
      try {
        const userResp = await api.get("/api/user/show");
        const user = userResp?.data?.user;
        const acesso = userResp?.data?.acesso;

        if (!user || !acesso) return;

        setUserIdLogado(user.id);
        setNomeUsuarioLogado(user.name);
        setTipoAcesso(acesso.tipo_acesso);

        if (acesso.tipo_acesso === "UBS") {
          setEstabelecimentoId(acesso?.rel_estabelecimento?.id || null);
          setNomeEstabelecimento(
            `${acesso?.rel_estabelecimento?.c_cnes || ""} - ${
              acesso?.rel_estabelecimento?.nome || ""
            }`
          );
        }

        if (acesso.tipo_acesso === "Municipio") {
          const relEstabelecimentoName = acesso?.rel_estabelecimento;
          const cidadesResp = await api.get("/api/cidade/list");
          const cidades = cidadesResp?.data?.data || [];

          const found = cidades.find(
            (c) => c.municipio === relEstabelecimentoName
          );

          if (found) setCodigoMunicipioUsuario(found.codigo_municipio);
        }
      } catch (err) {
        console.error("Erro ao carregar usuário:", err);
      }
    }
    loadUsuario();
  }, []);

  // carregar estabelecimentos (Municipio)
  useEffect(() => {
    async function loadEstabelecimentos() {
      if (!codigoMunicipioUsuario) return;
      try {
        const { data } = await api.get("/api/cnes/list", {
          params: { codigo_municipio: codigoMunicipioUsuario, per_page: 100 },
        });
        setEstabelecimentos(data?.data?.data || []);
      } catch (err) {
        console.error("Erro ao carregar estabelecimentos:", err);
      }
    }
    loadEstabelecimentos();
  }, [codigoMunicipioUsuario]);

  // carregar usuários do CNES selecionado
  useEffect(() => {
    async function loadUsuarios() {
      if (!selectedCnes) {
        setUsuarios([]);
        setSelectedUserId("");
        return;
      }

      try {
        const { data } = await api.get("/api/user/list");

        const filtrados = data.filter(
          (u) => u.rel_estabelecimento?.id === parseInt(selectedCnes)
        );

        setUsuarios(filtrados);
      } catch (err) {
        console.error("Erro ao carregar usuários:", err);
      }
    }
    loadUsuarios();
  }, [selectedCnes]);

  // datas padrão (últimos 7 dias)
  useEffect(() => {
    const hoje = new Date();
    const seteDiasAtras = new Date();
    seteDiasAtras.setDate(hoje.getDate() - 6);

    const formatDate = (date) => {
      return date.toISOString().split("T")[0];
    };

    setDataInicio(formatDate(seteDiasAtras));
    setDataFim(formatDate(hoje));
  }, []);

  const validarIntervaloDatas = (inicio, fim) => {
    const di = new Date(inicio);
    const df = new Date(fim);
    const diff = (df - di) / (1000 * 60 * 60 * 24);
    return diff <= 6; // 7 dias contando início + fim
  };

  // FILTRO
  const handleFiltrar = async (page = 1) => {
    if (!dataInicio || !dataFim) {
      setErro("Por favor, preencha ambas as datas.");
      return;
    }

    if (!validarIntervaloDatas(dataInicio, dataFim)) {
      setErro("O intervalo máximo permitido é de 7 dias.");
      return;
    }

    setErro("");
    setLoading(true);

    try {
      let params = {
        inicio: formatarDataParaAPI(dataInicio),
        fim: formatarDataParaAPI(dataFim, true),
        page: page - 1,
        size: 7,
      };

      if (tipoAcesso === "UBS") {
        params.userId = userIdLogado;
        params.codigoLocal = estabelecimentoId;
      } else {
        if (selectedUserId) params.userId = selectedUserId;
        if (selectedCnes) params.codigoLocal = selectedCnes;
      }

      const response = await api.get("/api/tracking/relatorios/acessos/dados", {
        params,
      });

      setRelatorios(response.data.content || []);
      setTotalAcesso(response.data.totalElements || 0);
      setCurrentPage(response.data.number + 1);
      setTotalPages(response.data.totalPages || 1);
    } catch (error) {
      console.error("Erro:", error);
      setErro("Erro ao buscar relatórios.");
    } finally {
      setLoading(false);
    }
  };

  // IMPRIMIR PDF
  const handleImprimir = async () => {
    if (!dataInicio || !dataFim) {
      setErro("Por favor, preencha ambas as datas.");
      return;
    }

    setImprimindo(true);

    try {
      let params = {
        inicio: formatarDataParaAPI(dataInicio),
        fim: formatarDataParaAPI(dataFim, true),
      };

      if (tipoAcesso === "UBS") {
        params.userId = userIdLogado;
        params.codigoLocal = estabelecimentoId;
      } else {
        if (selectedUserId) params.userId = selectedUserId;
        if (selectedCnes) params.codigoLocal = selectedCnes;
      }

      const response = await api.get("/api/tracking/relatorios/acessos", {
        params,
        responseType: "blob",
      });

      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(pdfBlob);
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      console.error("Erro PDF:", error);
      setErro("Erro ao gerar PDF.");
    } finally {
      setImprimindo(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleFiltrar(page);
  };

  const handleLimparFiltros = () => {
    setSelectedCnes("");
    setSelectedUserId("");
    setRelatorios([]);
    setTotalAcesso(0);

    const hoje = new Date();
    const seteDiasAtras = new Date();
    seteDiasAtras.setDate(hoje.getDate() - 6);

    setDataInicio(hoje.toISOString().split("T")[0]);
    setDataFim(seteDiasAtras.toISOString().split("T")[0]);
  };

  const columns = [
    { title: "Código Usuário", dataIndex: "codigoUsuario" },
    { title: "Nome Usuário", dataIndex: "nomeUsuario" },
    { title: "Tipo Acesso", dataIndex: "descricaoAcesso" },
    { title: "Local", dataIndex: "local" },
    {
      title: "Data/Hora Acesso",
      dataIndex: "dataLog",
      render: (dataLog) =>
        dataLog ? new Date(dataLog).toLocaleString("pt-BR") : "-",
    },
    { title: "Código Local", dataIndex: "codigoLocal" },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Relatório de Acessos</h4>
            </div>
          </div>
        </div>

        {erro && (
          <div className="alert alert-warning fade show">
            <strong>Atenção!</strong> {erro}
            <button className="btn-close" onClick={() => setErro("")}></button>
          </div>
        )}

        {/* FILTROS */}
        <div className="row mb-3">
          <div className="col-md-2">
            <label>Data Início:</label>
            <input
              type="date"
              className="form-control"
              value={dataInicio}
              onChange={(e) => setDataInicio(e.target.value)}
            />
          </div>

          <div className="col-md-2">
            <label>Data Fim:</label>
            <input
              type="date"
              className="form-control"
              value={dataFim}
              onChange={(e) => setDataFim(e.target.value)}
            />
          </div>

          {tipoAcesso === "Municipio" && (
            <>
              <div className="col-md-2">
                <label>Estabelecimento:</label>
                <select
                  className="form-select"
                  value={selectedCnes}
                  onChange={(e) => setSelectedCnes(e.target.value)}
                >
                  <option value="">Selecione...</option>
                  {estabelecimentos.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.c_cnes} - {e.nome}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2">
                <label>Usuário (opcional):</label>
                <select
                  className="form-select"
                  value={selectedUserId}
                  onChange={(e) => setSelectedUserId(e.target.value)}
                  disabled={!selectedCnes}
                >
                  <option value="">Todos</option>
                  {usuarios.map((u) => (
                    <option key={u.rel_user.id} value={u.rel_user.id}>
                      {u.rel_user.id} - {u.rel_user.name}
                    </option>
                  ))}
                </select>
              </div>
            </>
          )}

          {tipoAcesso === "UBS" && (
            <>
              <div className="col-md-3">
                <label>Estabelecimento:</label>
                <input
                  type="text"
                  className="form-control"
                  readOnly
                  value={nomeEstabelecimento}
                />
              </div>

              <div className="col-md-3">
                <label>Usuário:</label>
                <input
                  type="text"
                  readOnly
                  className="form-control"
                  value={nomeUsuarioLogado}
                />
              </div>
            </>
          )}

          <div className="col-md-2 d-flex align-items-end">
            <button
              className="btn btn-primary w-100"
              onClick={() => handleFiltrar(1)}
              disabled={loading}
            >
              {loading ? "Carregando..." : "Filtrar"}
            </button>
          </div>

          <div className="col-md-1 d-flex align-items-end">
            <button
              className="btn btn-outline-primary w-100"
              onClick={handleLimparFiltros}
            >
              Limpar
            </button>
          </div>
        </div>

        {/* TABELA */}
        <div className="card">
          <div className="card-body">
            <Table
              columns={columns}
              dataSource={relatorios}
              pagination={{
                current: currentPage,
                total: totalAcesso,
                pageSize: 7,
                onChange: handlePageChange,
                showQuickJumper: true,
              }}
              loading={loading}
            />

            {totalAcesso > 0 && (
              <div className="mt-3 fw-bold">
                Total de acessos: {totalAcesso}
              </div>
            )}

            <div className="d-flex justify-content-end mt-3">
              <button
                className="btn btn-primary"
                onClick={handleImprimir}
                disabled={imprimindo || relatorios.length === 0}
              >
                {imprimindo ? "Gerando..." : "Imprimir PDF"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsuarioAcessoRelatorioPage;
